import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';

interface OnboardingRouteProps {
  children: React.ReactNode;
}

export function OnboardingRoute({ children }: OnboardingRouteProps) {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Not authenticated - redirect to login
    return <Navigate to="/auth/login" replace />;
  }

  if (user?.onboarding_completed) {
    // User has completed onboarding - redirect to projects
    return <Navigate to="/projects" replace />;
  }

  // User hasn't completed onboarding - show the onboarding page
  return <>{children}</>;
}